export function progress(target, durationMs, steps, completedText, completedFunction) {
    const timeOut = durationMs / steps;

    /* Elements */
    const labelValueEl = document.getElementById('progress-bar__value');
    const indicatorValueEl = document.getElementById('progress-bar__indicator-value');
    const labelEl = document.getElementById('progress-bar__step-description');

    let i = 0;

    // This block will be executed x(steps) times.
    setInterval(function () {
        if (i === steps) {
            clearInterval(this);

            labelEl.innerText = completedText;

            completedFunction();
        } else {
            i++;
            setCount(i);
        }
    }, timeOut);

    function setCount(count) {
        labelValueEl.innerText = count;
        indicatorValueEl.setAttribute('aria-valuenow', count.toString());
    }
}
